export default __webpack_public_path__ + "static/media/6.bd70dc6c.svg";